import { KeyTitlesAddItem } from "./KeyTitlesAddItem";
import { ReuseTooltip } from "../../ui";
import { Button } from "@mui/material";
import { useState } from "react";
import { JobTitlesType } from "../../../types/enums";
import { PlusIcon } from "../../images";

type Props = {
  isReachedLimit: boolean;
  roleId: string;
  titleType: JobTitlesType;
  customAddHandler?: (
    title: string,
    group: string,
    onSuccess: () => void,
  ) => void;
  isDisabled?: boolean;
  btnText?: string;
  placeholder?: string;
};
export const KeyTitleAddItemBlock = ({
  roleId,
  isReachedLimit,
  titleType,
  customAddHandler,
  isDisabled,
  btnText = "Add Title",
  placeholder = "Enter job title",
}: Props) => {
  const [addIsOpen, setAddIsOpen] = useState(false);
  return (
    <>
      {addIsOpen ? (
        <KeyTitlesAddItem
          placeholder={placeholder}
          setIsOpen={setAddIsOpen}
          roleId={roleId}
          isIgnored={titleType === JobTitlesType.ignored}
          customAddHandler={customAddHandler}
        />
      ) : (
        <ReuseTooltip
          text={isReachedLimit ? "" : "Limit reached"}
          hideChildren={false}
        >
          <Button
            className="no-drag"
            onClick={() => isReachedLimit && !isDisabled && setAddIsOpen(true)}
            sx={{
              color: "#1C3C6C",
              textWrap: "nowrap",
              backgroundColor: "transparent",
              maxHeight: "32px",
              fontWeight: 500,
              opacity: isDisabled ? 0.6 : 1,
              cursor: isDisabled ? "auto" : "pointer",
              "&:hover": {
                opacity: 0.7,
              },
            }}
            startIcon={<PlusIcon color={"#1C3C6C"} />}
          >
            {btnText}
          </Button>
        </ReuseTooltip>
      )}
    </>
  );
};
